import { Component, Input, OnInit } from '@angular/core';
import { ImmersionCourseService } from '../../shared/immersion-course.service';
import { LevelProgressService } from '../../shared/level-progress/level-progress.service';
import { DEFAULT_CAROUSEL_SETTINGS } from '../../shared/types/CarouselSettings';
import { CourseContentType } from '../../shared/types/course-content-type';
import { ImmersionCarouselComponent } from '../immersion-carousel/immersion-carousel.component';
import { ImmersionCarouselService } from '../immersion-carousel/immersion-carousel.service';

@Component({
    selector: 'lp2-industry-content-carousel',
    templateUrl: './industry-content-carousel.component.html'
})
export class IndustryContentCarouselComponent extends ImmersionCarouselComponent implements OnInit {

    carouselSettings = DEFAULT_CAROUSEL_SETTINGS;
    showPreviousLevelsLink = false;
    currentLevel: number;
    filteredStatuses: string[] = [];
    sortBy = 'SEQUENCE';

    @Input() title: string;
    @Input() industry: string;
    @Input() id: number;
    @Input() showLink = true;
    @Input() shouldSaveTime = false;
    @Input() set level(value: number) {
        this.currentLevel = value;
        this.showPreviousLevelsLink = this.showLink && value && value > 1;
    }

    constructor(
        public service: ImmersionCarouselService,
        public levelProgressService: LevelProgressService,
        private readonly immersionCourseService: ImmersionCourseService) {
        super(service, levelProgressService, 'INDUSTRY');
        this.subscription.add(
            this.immersionCourseService.onCourseSaved(CourseContentType.ISC).subscribe(({ id }) => {
                this.reloadCourseTileById(id);
            })
        );
    }

    ngOnInit() {
        this.extraParams = [
            {key: 'includedTags', value: this.industry},
            {key: 'levelNum', value: this.currentLevel}
        ];

        super.ngOnInit();
    }
}



// WEBPACK FOOTER //
// ./ts/app/home/industry-content-carousel/industry-content-carousel.component.ts